export const KNOW_BEFORE = "Know before you rebook"
export const ALL_REBOOKS = (city: string, code: string) => 
  `All rebooking options through Capital One Travel will fly you to <b>${city}</b> (${code}).`
export const COLLECT_BAGGAGE = 'You will need to collect and re-check any baggage onto your new connecting flight. Additional baggage fees may apply in some cases.'
export const EMBEDDED_FLIGHT = '<b>By rebooking this connecting flight, you are required to rebook your return flight</b>. Once you choose your new connecting outbound flight, you will be forced to select a new return flight.'

